<script lang="ts">
	import { storefront_prefix } from 'shared/var'
	import { onMount } from 'svelte'
	import { cookie_to_object } from 'shared/cookie'

	let cart_qty = 0
	let prev_cookie = ``

	onMount(() => {
		setInterval(() => {
			if (prev_cookie === document.cookie) {
				return
			}

			cart_qty = Number(cookie_to_object(document.cookie).woocommerce_cart_quantity) || 0

			prev_cookie = document.cookie
		}, 100)
	})
</script>

<div class="personal">
	<a href={`${ storefront_prefix }/my-account/`}>
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="112 0 800 1024" fill="currentColor" style="transform: rotate(180deg)"><path d="M512 340.667c114 0 342-56 342-170v-86h-684v86c0 114 228 170 342 170zM512 426.667c-94 0-170 76-170 170s76 172 170 172 170-78 170-172-76-170-170-170z"/></svg>
		<span class="label">My Account</span>
	</a>
	<a href={`${ storefront_prefix }/cart/`}>
		<div class="cart_icon">
			{#if cart_qty > 0}
				<div class="cart_qty">{cart_qty}</div>
			{/if}
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 951 1024" fill="currentColor"><path d="M365.714 886.857c0 40-33.143 73.143-73.143 73.143s-73.143-33.143-73.143-73.143 33.143-73.143 73.143-73.143 73.143 33.143 73.143 73.143zM877.714 886.857c0 40-33.143 73.143-73.143 73.143s-73.143-33.143-73.143-73.143 33.143-73.143 73.143-73.143 73.143 33.143 73.143 73.143zM950.857 265.143v292.571c0 18.286-14.286 34.286-32.571 36.571l-596.571 69.714c2.857 13.143 7.429 26.286 7.429 40 0 13.143-8 25.143-13.714 36.571h525.714c20 0 36.571 16.571 36.571 36.571s-16.571 36.571-36.571 36.571h-585.143c-20 0-36.571-16.571-36.571-36.571 0-17.714 25.714-60.571 34.857-78.286l-101.143-470.286h-116.571c-20 0-36.571-16.571-36.571-36.571s16.571-36.571 36.571-36.571h146.286c38.286 0 39.429 45.714 45.143 73.143h686.286c20 0 36.571 16.571 36.571 36.571z"/></svg>
		</div>
		<span class="label">Cart</span>
	</a>
</div>

<style>
	.personal {
		display: flex;
		align-items: center;
	}

	a {
		display: flex;
		gap: 6px;
		align-items: center;
		font-weight: 500;
		color: white;
		padding: 0 5px;
		text-decoration: none;
		font-size: 1rem;
	}

	a:hover {
		text-decoration: none;
	}

	svg {
		display: block;
	}

	.cart_icon {
		position: relative;
	}

	.cart_qty {
		position: absolute;
		font-size: 12px;
		z-index: 1;
		top: 1px;
		left: 5px;
		right: 0;
		color: #000;
		line-height: 1;
		text-align: center;
		text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	}

	@media(width <= 800px) {
		.label {
			display: none;
		}
	}
</style>
